import React from "react";
import { Modal, Feed, Label } from "semantic-ui-react";
import SecondaryBlueButton from "components/Buttons/SecondaryBlueButton";
import moment from "moment";

const getHistoStatus = (histo) => {
	return (
		<Feed.Event key={histo.id}>
			<Feed.Label icon={getHistoIcon(histo)} />
			<Feed.Content>
				<Feed.Meta>
					{histo.user && histo.user.first_name !== "HelpNurse" && (
						<Feed.User>
							{histo.user.first_name} {histo.user.last_name}
						</Feed.User>
					)}
					{histo.user && histo.user.first_name === "HelpNurse" && <Feed.User>Automatiquement</Feed.User>}
				</Feed.Meta>
				<Feed.Summary>
					{getCancellationReason(histo)}
					{getSimpleStatus(histo)}
					<Feed.Date>
						{moment(histo.created_at).format(`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`)}
					</Feed.Date>
				</Feed.Summary>
			</Feed.Content>
		</Feed.Event>
	);
};

const getHistoIcon = (histo) => {
	if (histo.comment) return "comment alternate outline";
	if (histo.status_from === "ASSIGNED" && histo.status_to === "NEW") return "history";
	if (histo.status_to === "PENDING") return "wait";
	if (histo.status_to === "DONE") return "calendar check";
	if (histo.status_to === "CANCELED") return "calendar times";
	if (histo.status_to === "SUPPORT") return "pencil alternate";
	if (histo.status_to === "ASSIGNED") return "sign-out";
	if (histo.status_to === "REASSIGNED") return "sign-in";
	if (histo.status_to === "NEW") return "calendar plus";
};

const getCancellationReason = (c) => {
	if (c.cancellation && c.cancelReason)
		return (
			<div>
				<Label ribbon>
					<span style={{ fontSize: "0.9rem" }}>Annulation de la demande de télésecrétariat : </span>
					{c.cancelReason.label}
				</Label>
			</div>
		);
	return;
};
const getSimpleStatus = (histo) => {
	if (histo.comment) return <span>{histo.comment}</span>;
	return (
		<span>
			{histo.status_from === "ASSIGNED" && histo.status_to === "NEW" && <>Intervention télésecrétariat replacé en file d'attente</>}
			{histo.status_to === "PENDING" && <>Intervention télésecrétariat replacé en file d'attente et en attente d'un.e secrétaire senior</>}
			{histo.status_to === "DONE" && <>Intervention télésecrétariat terminée</>}
			{(histo.status_to === "CANCELED" || histo.status_to === "CANCELEDBYSEC") && <>Intervention télésecrétariat annulée</>}
			{histo.status_to === "SUPPORT" && (
				<>Intervention télésecrétariat prise en charge {histo.assignedTo ? `par ${histo.assignedTo.first_name} ${histo.assignedTo.last_name}` : ""}</>
			)}

			{histo.status_to === "ASSIGNED" && (
				<>
					Intervention télésecrétariat assignée à {histo.assignedTo ? histo.assignedTo.first_name : ""}{" "}
					{histo.assignedTo ? histo.assignedTo.last_name : ""}
				</>
			)}
			{histo.status_to === "REASSIGNED" && (
				<>
					Intervention télésecrétariat complétée{" "}
					{histo.assignedTo
						? ` et réassignée à  ${histo.assignedTo.first_name} ${histo.assignedTo.last_name}`
						: " et en attente de la venue du patient en centre."}
				</>
			)}

			{histo.status_from === "" && histo.status_to === "NEW" && <>Nouvelle demande d'intervention télésecrétariat</>}
		</span>
	);
};

const HistoricNurseHelpModal = ({ open, closeHistoricFolderHelpModal, folderHelp }) => {
	return (
		folderHelp &&
		folderHelp.historics !== undefined && (
			<Modal closeIcon open={open} closeOnEscape closeOnDimmerClick onClose={closeHistoricFolderHelpModal}>
				<Modal.Header>Historique</Modal.Header>
				<Modal.Content>
					<Feed size="large">
						{folderHelp.historics
							.concat(
								folderHelp.comments.map((c) => {
									return { ...c, user: c.created_by };
								})
							)
							.sort((a, b) => moment(a.created_at) - moment(b.created_at))
							.map((h) => getHistoStatus(h))}
					</Feed>
				</Modal.Content>
				<Modal.Actions>
					<SecondaryBlueButton
						negative
						onClick={() => {
							closeHistoricFolderHelpModal();
						}}
					>
						Fermer
					</SecondaryBlueButton>
				</Modal.Actions>
			</Modal>
		)
	);
};

export default HistoricNurseHelpModal;
